import { EmptyObject } from '../../EmptyObject';

export const ManagementRemoteControlEnableRequest = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlEnableRequest';
export interface ManagementRemoteControlEnableRequest {
	type: typeof ManagementRemoteControlEnableRequest;
}

export const ManagementRemoteControlEnableResult = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlEnableResult';
export interface ManagementRemoteControlEnableResult {
	type: typeof ManagementRemoteControlEnableResult;
	result: EmptyObject;
}

export const ManagementRemoteControlDisableRequest = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlDisableRequest';
export interface ManagementRemoteControlDisableRequest {
	type: typeof ManagementRemoteControlDisableRequest;
}

export const ManagementRemoteControlDisableResult = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlDisableResult';
export interface ManagementRemoteControlDisableResult {
	type: typeof ManagementRemoteControlDisableResult;
	result: EmptyObject;
}

export const ManagementRemoteControlIsEnabledRequest = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlIsEnabledRequest';
export interface ManagementRemoteControlIsEnabledRequest {
	type: typeof ManagementRemoteControlIsEnabledRequest;
}

export const ManagementRemoteControlIsEnabledResult = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlIsEnabledResult';
export interface ManagementRemoteControlIsEnabledResult {
	type: typeof ManagementRemoteControlIsEnabledResult;
	result: boolean;
}

export const ManagementRemoteControlLockRequest = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlLockRequest';
export interface ManagementRemoteControlLockRequest {
	type: typeof ManagementRemoteControlLockRequest;
}

export const ManagementRemoteControlLockResult = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlLockResult';
export interface ManagementRemoteControlLockResult {
	type: typeof ManagementRemoteControlLockResult;
	result: EmptyObject;
}

export const ManagementRemoteControlUnlockRequest = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlUnlockRequest';
export interface ManagementRemoteControlUnlockRequest {
	type: typeof ManagementRemoteControlUnlockRequest;
}

export const ManagementRemoteControlUnlockResult = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlUnlockResult';
export interface ManagementRemoteControlUnlockResult {
	type: typeof ManagementRemoteControlUnlockResult;
	result: EmptyObject;
}

export const ManagementRemoteControlIsLockedRequest = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlIsLockedRequest';
export interface ManagementRemoteControlIsLockedRequest {
	type: typeof ManagementRemoteControlIsLockedRequest;
}

export const ManagementRemoteControlIsLockedResult = 'sos.Monitoring.Management.RemoteControl.ManagementRemoteControlIsLockedResult';
export interface ManagementRemoteControlIsLockedResult {
	type: typeof ManagementRemoteControlIsLockedResult;
	result: boolean;
}

export type ManagementRemoteControlRequests =
	| ManagementRemoteControlEnableRequest
	| ManagementRemoteControlDisableRequest
	| ManagementRemoteControlIsEnabledRequest
	| ManagementRemoteControlLockRequest
	| ManagementRemoteControlUnlockRequest
	| ManagementRemoteControlIsLockedRequest;
